import { lazy } from 'react';
import { Route } from 'react-router';
import RequireAuth from '../../components/RequireAuth';

const DashboardRoute = lazy(() => import('./Dashboard'));
const VersionsRoute = lazy(() => import('./Versions'));
const MyProfileRoute = lazy(() => import('./MyProfile'));
const SignInRoute = lazy(() => import('./SignIn'));
const CallbackRoute = lazy(() => import('./Callback'));
const OopsRoute = lazy(() => import('./Oops'));
const UnauthorizedRoute = lazy(() => import('./Unauthorized'));

export default [
  <Route key="login" path="/login" element={<SignInRoute />} />,
  <Route key="callback" path="/callback" element={<CallbackRoute />} />,
  <Route key="oops" path="/oops" element={<OopsRoute />} />,
  <Route key="unauthorized" path="/unauthorized" element={<UnauthorizedRoute />} />,
  <Route
    key="dashboard"
    path="/"
    element={
      <RequireAuth>
        <DashboardRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="versions"
    path="/versions"
    element={
      <RequireAuth>
        <VersionsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="my-profile"
    path="/my-profile"
    element={
      <RequireAuth>
        <MyProfileRoute />
      </RequireAuth>
    }
  />,
];
